<script setup lang="ts">
import type { Toast } from '@/stores/notifications'
import { useNotificationStore } from '@/stores/notifications'

interface Props {
  toast: Toast
}

defineProps<Props>()

const notifications = useNotificationStore()

const icons = {
  success: 'M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z',
  error:   'M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z',
  warning: 'M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z',
  info:    'M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z',
}

const colors = {
  success: 'border-green-700 bg-green-900/40',
  error:   'border-red-700 bg-red-900/40',
  warning: 'border-yellow-700 bg-yellow-900/40',
  info:    'border-blue-700 bg-blue-900/40',
}

const iconColors = {
  success: 'text-green-400',
  error:   'text-red-400',
  warning: 'text-yellow-400',
  info:    'text-blue-400',
}
</script>

<template>
  <div
    :class="['flex items-start gap-3 px-4 py-3 rounded-lg border backdrop-blur shadow-lg min-w-64 max-w-sm', colors[toast.type]]"
    role="alert"
  >
    <svg class="w-5 h-5 shrink-0 mt-0.5" :class="iconColors[toast.type]" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
      <path stroke-linecap="round" stroke-linejoin="round" :d="icons[toast.type]" />
    </svg>
    <div class="flex-1 min-w-0">
      <p class="text-sm font-medium text-text-primary">{{ toast.title }}</p>
      <p v-if="toast.message" class="text-xs text-text-muted mt-0.5">{{ toast.message }}</p>
    </div>
    <button
      class="shrink-0 p-0.5 text-text-muted hover:text-text-primary transition-colors"
      @click="notifications.removeToast(toast.id)"
    >
      <svg class="w-3.5 h-3.5" viewBox="0 0 20 20" fill="currentColor">
        <path d="M6.28 5.22a.75.75 0 00-1.06 1.06L8.94 10l-3.72 3.72a.75.75 0 101.06 1.06L10 11.06l3.72 3.72a.75.75 0 101.06-1.06L11.06 10l3.72-3.72a.75.75 0 00-1.06-1.06L10 8.94 6.28 5.22z" />
      </svg>
    </button>
  </div>
</template>
